'use strict';

// Import Libraries
import React from 'react';
// Import JS Modules
import { builderDispatch }   from '../_utils/ui';
import CartItemsChangeEvents from './cart-items-change-events';
import DeletionFirmness      from './deletion-firmness';

// -----------------------------------------------------------
//  PrismItemDeleted
// -----------------------------------------------------------
var PrismItemDeleted = (props) => {
  const action = (({deleted}) => {
    if (deleted == DeletionFirmness.SOFT)
      return 'saved for later';

    return 'deleted';
  })(props);

  return (
    <div className="alert alert-warning deleted-warning" role="alert">
      { props.title } has been <span className="action-text">{ action }</span>&nbsp;
      <a href="#" onClick={ handleUndelete }>Undo</a>
    </div>
  );

  function handleUndelete(e) {
    e.preventDefault();

    builderDispatch.dispatch({
      type: CartItemsChangeEvents.UNREMOVE_PRISM,
      item: {
        id: props.id,
        prism_id: props.prism_id
      }
    });
  }
};

PrismItemDeleted.displayName = 'Prism Item Deleted';

export default PrismItemDeleted;
